export function findNewObjects(array1, array2) {
  const array1Ids = array1.map(item => item.id);
  return array2.filter(item => !array1Ids.includes(item.id));
}

export function findNewUniqueObjects(array1, array2) {
  const array1Ids = array1.map(item => item.uniqueId);
  return array2.filter(item => !array1Ids.includes(item.uniqueId));
}


export function uniqueNameForObject(object, array) {
  let uniqueCounter = 1;
  let uniqueName = object?.UniqueName;
  const existingNames = array.map(item => item?.UniqueName);

  while (existingNames.includes(uniqueName)) {
    uniqueName = `${object?.UniqueName}_${uniqueCounter}`;
    uniqueCounter++;
  }

  return { ...object, UniqueName: uniqueName };
}

export function uniqueNumberForObject(object, array) {
  let uniqueCounter = 1;
  let uniqueNumber = object?.uniqueNumber;
  const existingNames = array.filter(item => item?.name === object.name).map(item => item.uniqueNumber);
  while (existingNames?.includes(uniqueNumber)) {
    uniqueNumber = `${uniqueCounter}`;
    uniqueCounter++;
  }

  return { ...object, uniqueNumber: uniqueNumber };
}

export const renameDuplicate = (source) => {
  let output = Object.values(
    source.reduce((a, e, i) => {
      let testId = e?.UniqueName.toString();
      if (a[testId]) {
        testId = testId.split("_")[0] + "_" + (i + 1);
      }
      a[testId] = { ...e, UniqueName: testId };
      return a;
    }, {})
  );
  return output
}

export const renameFieldDuplicate = (source) => {
  let output = Object.values(
    source.reduce((a, e, i) => {
      let testId = e.fieldName.toString();
      let s_Label = e.label.toString();
      if (a[testId]) {
        testId = testId.split("_")[0] + "_" + (i + 1);
        s_Label = s_Label.split("_")[0] + "_" + (i + 1);
      }
      a[testId] = { ...e, fieldName: testId, label: s_Label };
      return a;
    }, {})
  );
  return output
}